var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M315,334.7c-10.9,0-19.6,8.9-19.6,19.8v49.2c0,4.1-0.8,8-2.3,11.5c-2.2,5.3-6,9.8-10.7,13c-2.4,1.6-5,2.8-7.7,3.7 c-2.8,0.9-5.7,1.3-8.8,1.3h-197c-4.1,0-8-0.8-11.5-2.3c-5.3-2.2-9.8-6-13-10.7c-1.6-2.4-2.8-5-3.7-7.7c-0.9-2.8-1.3-5.7-1.3-8.8 V108.3c0-4.1,0.8-8,2.3-11.5c2.2-5.3,6-9.8,10.7-13c2.4-1.6,5-2.9,7.7-3.7c2.8-0.9,5.7-1.3,8.8-1.3H256c4.1,0,9.1,0.9,13.9,2.7 c3.7,1.3,7.3,3.2,10.5,5.3c4.9,3.2,8.9,7.2,11.4,11c1.3,1.9,2.1,3.8,2.7,5.5c0.6,1.8,0.8,3.4,0.8,5v49.2c0,10.9,8.8,19.7,19.7,19.7 s19.7-8.8,19.7-19.7v-49.2c0-5.3-0.8-10.5-2.2-15.4c-2.5-8.5-6.8-16.1-12-22.6c-4-4.9-8.5-9.2-13.4-12.9 c-7.3-5.6-15.5-10-24.1-13.2c-8.6-3.1-17.7-4.9-27.1-4.9h-187c-9.5,0-18.6,1.9-26.8,5.4c-12.4,5.2-22.9,14-30.3,24.9 c-3.7,5.5-6.7,11.6-8.7,18.1S0,101.1,0,108.2v295.4c0,9.5,1.9,18.6,5.4,26.8c5.2,12.4,14,22.9,24.9,30.3c5.5,3.7,11.6,6.7,18.1,8.7 s13.4,3.1,20.5,3.1h196.9c9.5,0,18.6-1.9,26.8-5.4c12.4-5.2,22.9-14,30.3-24.9c3.7-5.5,6.7-11.6,8.7-18.1s3.1-13.4,3.1-20.5v-49.2 C334.7,343.5,325.9,334.7,315,334.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M506.3,242.1l-98.5-98.5c-7.7-7.7-20.2-7.7-27.8,0c-7.7,7.7-7.7,20.2,0,27.8l64.9,64.9H157.5c-10.9,0-19.7,8.8-19.7,19.7 c0,10.9,8.9,19.7,19.7,19.7h287.2L380,340.4c-7.7,7.7-7.7,20.2,0,27.8c7.6,7.9,20.1,7.9,27.8,0.2l98.5-98.5 c3.7-3.7,5.8-8.7,5.8-13.9C512.1,250.8,510,245.7,506.3,242.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.0774eb1becfd765d23fa2e8e96a9b6a4.svg";
export { ForwardRef as ReactComponent };